module.exports = __webpack_public_path__ + "static/media/triangle-music.ada6bdd6.svg";